module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-264.5513b065.svg";